import { History } from "history";

import {
  DELETE_COURSE_DURATION,
  DELETE_COURSE_DURATION_CONSENT,
  DELETE_COURSE_DURATION_ERROR,
  DELETE_COURSE_DURATION_SUCCESS,
  DeleteCourseDurationAction,
  DeleteCourseDurationConsentAction,
  DeleteCourseDurationErrorAction,
  DeleteCourseDurationSuccessAction,
  GET_COURSE_DURATION,
  GET_COURSE_DURATIONS,
  GET_COURSE_DURATIONS_ERROR,
  GET_COURSE_DURATIONS_SUCCESS,
  GET_COURSE_DURATION_ERROR,
  GET_COURSE_DURATION_SUCCESS,
  GetCourseDurationAction,
  GetCourseDurationErrorAction,
  GetCourseDurationSuccessAction,
  GetCourseDurationsAction,
  GetCourseDurationsErrorAction,
  GetCourseDurationsSuccessAction,
  ROLLOVER,
  ROLLOVER_ERROR,
  ROLLOVER_SUCCESS,
  RolloverAction,
  RolloverErrorAction,
  RolloverSuccessAction,
  UPDATE_COURSE_DURATION,
  UPDATE_COURSE_DURATION_ERROR,
  UPDATE_COURSE_DURATION_SUCCESS,
  UpdateCourseDurationAction,
  UpdateCourseDurationErrorAction,
  UpdateCourseDurationSuccessAction,
} from "./actionTypes";
import { PaginateQuery, UpdateCourseDurationRequest } from "../../interfaces";
import { Paginated } from "../../models";
import { CourseDurationDto } from "../../interfaces/course";

//#region Get Course Durations

export const getCourseDurations = (
  gradeId: string,
  courseId: string,
  request: PaginateQuery,
  history: History
): GetCourseDurationsAction => {
  return {
    type: GET_COURSE_DURATIONS,
    payload: { gradeId, courseId, request, history },
  };
};

export const getCourseDurationsSuccess = (
  response: Paginated<CourseDurationDto>
): GetCourseDurationsSuccessAction => {
  return {
    type: GET_COURSE_DURATIONS_SUCCESS,
    payload: response,
  };
};

export const getCourseDurationsError = (
  error: any
): GetCourseDurationsErrorAction => {
  return {
    type: GET_COURSE_DURATIONS_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get CourseDuration

export const getCourseDuration = (
  id: string,
  history: History
): GetCourseDurationAction => {
  return {
    type: GET_COURSE_DURATION,
    payload: { id, history },
  };
};

export const getCourseDurationSuccess = (
  response: CourseDurationDto
): GetCourseDurationSuccessAction => {
  return {
    type: GET_COURSE_DURATION_SUCCESS,
    payload: response,
  };
};

export const getCourseDurationError = (
  error: any
): GetCourseDurationErrorAction => {
  return {
    type: GET_COURSE_DURATION_ERROR,
    payload: error,
  };
};

//#endregion

//#region Update CourseDuration

export const updateCourseDuration = (
  request: UpdateCourseDurationRequest[],
  history: History
): UpdateCourseDurationAction => {
  return {
    type: UPDATE_COURSE_DURATION,
    payload: { request, history },
  };
};

export const updateCourseDurationSuccess =
  (): UpdateCourseDurationSuccessAction => {
    return {
      type: UPDATE_COURSE_DURATION_SUCCESS,
      payload: null,
    };
  };

export const updateCourseDurationError = (
  error: any
): UpdateCourseDurationErrorAction => {
  return {
    type: UPDATE_COURSE_DURATION_ERROR,
    payload: error,
  };
};

//#endregion

//#region Delete CourseDuration

export const deleteCourseDurationConsent = (
  id: string
): DeleteCourseDurationConsentAction => {
  return {
    type: DELETE_COURSE_DURATION_CONSENT,
    payload: id,
  };
};

export const deleteCourseDuration = (
  id: string,
  history: History
): DeleteCourseDurationAction => {
  return {
    type: DELETE_COURSE_DURATION,
    payload: { id, history },
  };
};

export const deleteCourseDurationSuccess =
  (): DeleteCourseDurationSuccessAction => {
    return {
      type: DELETE_COURSE_DURATION_SUCCESS,
      payload: null,
    };
  };

export const deleteCourseDurationError = (
  error: any
): DeleteCourseDurationErrorAction => {
  return {
    type: DELETE_COURSE_DURATION_ERROR,
    payload: error,
  };
};

//#endregion

//#region Rollover

export const rollover = (): RolloverAction => {
  return {
    type: ROLLOVER,
    payload: {},
  };
};

export const rolloverSuccess = (): RolloverSuccessAction => {
  return {
    type: ROLLOVER_SUCCESS,
    payload: null,
  };
};

export const rolloverError = (error: any): RolloverErrorAction => {
  return {
    type: ROLLOVER_ERROR,
    payload: error,
  };
};

//#endregion
